// src/api/serverWrapper.js
import APPUrls, {
  ADD_DRS_BALL,
  ADD_DRS_MATCH,
  GET_DEPLOYMENT_SYSTEMS,
  GET_DRS_BALL,
  GET_DRS_MATCH,
  GET_DRS_TYPES,
  VIDEO_URLS,
} from "./app_urls";

import { doGetRequest, doPostRequest } from "./fetchcalls";

/**
 * Fetch DRS Types
 */
export const get_drs_tyes = async () => {
  return await doGetRequest(APPUrls.GET_DRS_TYPES);
};

/**
 * Add a DRS Match
 */
export const add_match = async (matchData) => {
  return await doPostRequest(APPUrls.ADD_DRS_MATCH, matchData);
};

/**
 * Fetch All DRS Matches
 */
export const get_drs_match = async () => {
  return await doGetRequest(APPUrls.GET_DRS_MATCH);
};

/**
 * Add a DRS Ball
 */
export const add_ball = async (ballData) => {
  return await doPostRequest(APPUrls.ADD_DRS_BALL, ballData);
};

/**
 * Fetch All DRS Balls
 */
export const get_drs_ball = async () => {
  return await doGetRequest(APPUrls.GET_DRS_BALL);
};

/**
 * Fetch Cricket Associations (Deployment Systems)
 */
export const get_cricket_asscotions = async () => {
  return await doGetRequest(APPUrls.GET_DEPLOYMENT_SYSTEMS);
};

/**
 * Get Video URLs (dynamic endpoint)
 */

export const get_video_urls = async (
  matchIdNum,
  innNumNum,
  overNumNum,
  ballNumNum,
  extraIndexNum,
  deploymentString
) => {
  // Construct the query string with the parameters
  const queryParams = `matchId=${matchIdNum}&innNum=${innNumNum}&overNum=${overNumNum}&ballNum=${ballNumNum}&extraIndex=${extraIndexNum}&deploymentId=${deploymentString}`;

  // Combine the base URL with the query string
  let url = `${APPUrls.FIXED_BASE_URL}score/match-video-url-association?${queryParams}`;

  console.log("Fetching ball URL:", url);

  // Perform the GET request to the constructed URL
  return await doGetRequest(url);
};

export const login_user = async (user) => {
  let url = APPUrls.FIXED_BASE_URL + "users/login-with-p";
  let response = await doPostRequest(url, user);
  return response;
};

export const get_user_by_id = async (userId) => {
  let url = APPUrls.FIXED_BASE_URL + "users/user-by-id";
  let response = await doGetRequest(url + "?userId=" + userId);
  return response;
};
